import type { RSheetColumn, RSheetRecordNode } from '../../../domain/column'
import { sheetAreaToCopyMatrix } from '../../../domain/copyMatrix'
import type { RSheetsCursor } from '../../../domain/cursor/cursorTypes'
import type { ExpandCursorArea } from '../../../recoil/cursor'
import type { NewRecordChange } from '../../action/addNewRecord/addNewRecords'
import { generateDeleteChangesFromArea } from '../../util/generateDeleteChangesFromArea'
import { getReferencedStreamNameNoOp } from '../../util/getReferencedStreamName'
import type { RecordChange } from '../../util/updateViewRecords'

// eslint-disable-next-line sonarjs/todo-tag
// TODO: mutationにする
export const deleteCellValues = (
  records: RSheetRecordNode[],
  columns: Array<RSheetColumn<RSheetRecordNode>>,
  cursor: RSheetsCursor,
  selectedArea: ExpandCursorArea,
): {
  newRecordChanges: NewRecordChange[]
  recordChanges: RecordChange[]
  errors: Array<{ message: string }>
} =>
  generateDeleteChangesFromArea({
    copyMatrix: sheetAreaToCopyMatrix(records, columns, selectedArea, getReferencedStreamNameNoOp),
    records,
    columns,
    cursor,
  })
